module.exports = __webpack_public_path__ + "img/clarity-video.30d942c8.png";